import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { BookOpen, ArrowLeft } from 'lucide-react';
import { useWiki } from '../../contexts/WikiContext';
import WikiExplore from './components/WikiExplore';
import WikiArticle from './components/WikiArticle';
import styles from './WikiExperience.module.css';

export default function WikiPage() {
  const { slug } = useParams();
  const location = useLocation();
  const { getPage, getAllPages, getCategoriesTree, loadPages, loadCategories, fetchPageBySlug, error } = useWiki();
  const [ready, setReady] = useState(false);
  const [lookup, setLookup] = useState({ slug: null, page: null, done: false });
  useEffect(() => {
    let active = true;
    Promise.all([loadPages(), loadCategories()]).then(() => { if (active) setReady(true); });
    return () => { active = false; };
  }, [loadPages, loadCategories]);
  const cached = slug ? getPage(slug) : null;
  useEffect(() => {
    if (!ready || !slug || cached || error) return undefined;
    let active = true;
    fetchPageBySlug(slug).then((page) => { if (active) setLookup({ slug, page, done: true }); });
    return () => { active = false; };
  }, [ready, slug, cached, fetchPageBySlug, error]);
  useEffect(() => { if (!location.hash) window.scrollTo(0, 0); }, [location.pathname, location.search, location.hash]);
  const page = cached || (lookup.slug === slug ? lookup.page : null);
  const pending = !ready || (slug && !page && !(lookup.slug === slug && lookup.done));
  const retry = async () => { setReady(false); await Promise.all([loadPages(), loadCategories()]); setReady(true); };
  return (
    <div className={styles.wiki}>
      {error ? <div className={styles.status} role="alert"><BookOpen size={36} /><h1>Вики временно недоступна</h1><p>Не удалось загрузить материалы. Попробуйте ещё раз.</p><button className={styles.primaryButton} onClick={retry}>Повторить</button></div>
        : pending ? <div className={styles.status} role="status"><BookOpen size={36} /><p>Открываем Вики…</p><div className={styles.loadingLine} /></div>
          : slug ? page ? <WikiArticle key={page.slug} page={page} pages={getAllPages()} tree={getCategoriesTree()} />
            : <div className={styles.status}><BookOpen size={36} /><h1>Статья не найдена</h1><p>Возможно, её переименовали. Найдите материал через поиск.</p><Link className={styles.primaryButton} to="/wiki"><ArrowLeft size={18} /> В Вики</Link></div>
            : <WikiExplore pages={getAllPages()} tree={getCategoriesTree()} />}
    </div>
  );
}
